/* Infinite announcement marquee.
 *
 * Replicates emestudios.com's marquee, including its arithmetic:
 *
 *   copies   = max(2, ceil(containerWidth / itemWidth) + 1)
 *   duration = max(4, itemWidth * copies / speed)      // speed in px/s
 *
 * The track holds TWO identical halves and slides translateX(0) -> -50%,
 * so half a track-width lands copy 2 exactly where copy 1 began and the loop
 * is seamless. The animation itself is pure CSS (see cc-marquee in
 * styles.css.liquid); this file only decides how wide the track has to be and
 * how long one lap should take.
 *
 * Both numbers have to be measured. A hard-coded copy count is either short
 * of a wide viewport — leaving a visible gap once per lap — or absurdly long
 * on a phone; and a hard-coded duration makes the text crawl or race
 * depending on how much of it the merchant typed.
 */
(function () {
  'use strict';

  /* px per second. Matches EME's default and is what the theme setting
     ultimately feeds in. */
  var DEFAULT_SPEED = 50;
  /* Below this, a short phrase on a narrow phone laps fast enough to read as
     a flicker rather than a scroll. */
  var MIN_DURATION = 4;

  var reduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;

  function build(root) {
    var track = root.querySelector('[data-marquee-track]');
    if (!track) return;

    /* Keep the pristine copy the first time through. After a rebuild the
       track holds N clones, so re-reading it would measure the previous fill
       and the count would grow on every resize. */
    var seed = root._marqueeSeed;
    if (!seed) {
      var first = track.querySelector('.cc-marquee__item');
      if (!first) return;
      seed = root._marqueeSeed = first.cloneNode(true);
    }

    /* Under reduced motion leave the single static copy in place. */
    if (reduceMotion && reduceMotion.matches) return;

    var probe = document.createElement('div');
    probe.className = 'cc-marquee__probe';
    probe.appendChild(seed.cloneNode(true));
    root.appendChild(probe);
    var itemWidth = probe.offsetWidth;
    root.removeChild(probe);

    var containerWidth = root.offsetWidth;
    /* Hidden tab, display:none ancestor, or a drawer that has not opened yet:
       every measurement is 0 and any maths on it produces a broken track.
       Leave the markup alone and wait to be called again. */
    if (!itemWidth || !containerWidth) return;

    var speed = parseFloat(root.getAttribute('data-marquee-speed')) || DEFAULT_SPEED;
    var copies = Math.max(2, Math.ceil(containerWidth / itemWidth) + 1);
    var duration = Math.max(MIN_DURATION, (itemWidth * copies) / speed);

    /* Skip the DOM churn when a resize did not actually change the answer —
       rebuilding restarts the animation, which reads as a visible jump. */
    if (root._marqueeCopies === copies) {
      track.style.animationDuration = duration + 's';
      return;
    }
    root._marqueeCopies = copies;

    var group = document.createElement('div');
    group.className = 'cc-marquee__group';
    for (var i = 0; i < copies; i++) {
      group.appendChild(seed.cloneNode(true));
    }

    /* The second half is decoration for the eye only — hidden from assistive
       tech so the announcement is not read out N times over. */
    var mirror = group.cloneNode(true);
    mirror.setAttribute('aria-hidden', 'true');

    track.textContent = '';
    track.appendChild(group);
    track.appendChild(mirror);
    track.style.animationDuration = duration + 's';
  }

  function buildAll() {
    var roots = document.querySelectorAll('[data-marquee]');
    for (var i = 0; i < roots.length; i++) build(roots[i]);
  }

  function init() {
    buildAll();

    /* Web fonts land after first paint and change the text's width, which
       would leave the track sized for the fallback font — usually a little
       short, so a gap appears once per lap. Re-measure once they are ready. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(buildAll);
    }

    var pending;
    window.addEventListener('resize', function () {
      clearTimeout(pending);
      pending = setTimeout(buildAll, 150);
    });

    /* Theme editor: re-render on section reload and on setting changes. */
    document.addEventListener('shopify:section:load', buildAll);
    document.addEventListener('shopify:section:select', buildAll);

    if (reduceMotion && reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', function () {
        /* Force a rebuild rather than an early return from the cache. */
        var roots = document.querySelectorAll('[data-marquee]');
        for (var i = 0; i < roots.length; i++) roots[i]._marqueeCopies = null;
        buildAll();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
